/**
 * Application Routes
 * Main routing configuration extracted from App.tsx
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppShell } from '../layout/AppShell';
import { ProjectsListPage, ProjectHomePage } from '../../features/dashboard/projects';
import { LoginPage, AuthLayout } from '../../features/system/auth';
import { UserProfile as UserProfilePage } from '../../features/dashboard/profile';
import '../../styles/prism-theme.css';

/**
 * AppRoutes - Main routing component
 */
export const AppRoutes: React.FC = () => {
  return (
    <Router>
      <AppShell>
        <Routes>
          <Route path="/" element={<ProjectsListPage />} />
          <Route path="/dashboard" element={<ProjectHomePage />} />
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<UserProfilePage />} />
          </Route>
        </Routes>
      </AppShell>
    </Router>
  );
};

export default AppRoutes;
